/** Formats a yyyy-MM-dd calendar day without shifting it across time zones. */
export function formatIsoDay(isoDay: string, language: string): string {
  const [y, m, d] = isoDay.split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString(language, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export function getEarlyRenewalDates(
  entry: { renewsOn: string; renewalOpensOn: string },
  language: string,
) {
  return {
    renewsOn: formatIsoDay(entry.renewsOn, language),
    opensOn: formatIsoDay(entry.renewalOpensOn, language),
  };
}
